"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOBILE_PAGESTATE_CONFIG = exports.MOBILE_ELEMENT_CONFIG = void 0;
/** Written into `node.target` at `convertMobileResult` time. */
exports.MOBILE_ELEMENT_CONFIG = {
    offspringDepth: 3,
    offspringMaxNodes: 50,
    disambiguation: 'ladder',
    ancestryMaxDepth: 5,
    enrichShortMaxChars: 30,
    enrichClassTopk: 3,
    enrichShortListing: 3
};
/** Written into `results.url` at `convertMobileResult` time. */
exports.MOBILE_PAGESTATE_CONFIG = {
    tokenFields: ['role', 'text'],
    salientDepth: 5,
    labeledLevels: 2,
    wrapperDenylist: [
        'ConstraintLayout',
        'CoordinatorLayout',
        'FrameLayout',
        'LinearLayout',
        'RelativeLayout',
        'UIDropShadowView',
        'UILayoutContainerView',
        'UINavigationTransitionView',
        'UITransitionView',
        'UIView',
        'UIViewControllerWrapperView',
        'ViewGroup'
    ],
    substructureMaxLines: 50
};
//# sourceMappingURL=productionConfig.js.map